/**
 * @desc 查询预告公告分页列表
 */
import {
  PageAnnouncementEntity,
  AnnouncementPageQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAnnouncementPageParameter = AnnouncementPageQuery

const method = 'GET'
const url = '/trade/operation/announcement/page'

export const queryAnnouncementPageApi = (
  params?: QueryAnnouncementPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageAnnouncementEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAnnouncementPageApi.method = method
queryAnnouncementPageApi.url = url
